import {Component, Inject, OnInit, ViewChild, ViewContainerRef} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Observable, takeUntil} from 'rxjs';
import {BaseComponent} from '../../base-component';
import {ContentComponentInput} from './content-switcher-component-input.interface';

@Component({
  templateUrl: './content-switcher-dialog.component.html',
  styleUrls: ['./content-switcher-dialog.component.scss']
})
export class ContentSwitcherDialogComponent extends BaseComponent implements OnInit {
  @ViewChild('contentSwitcherContainer', {read: ViewContainerRef, static: true}) private readonly contentSwitcherContainer: ViewContainerRef;

  private readonly nextComponentRefAndInfo: Observable<ContentComponentInput>;

  public constructor(@Inject(MAT_DIALOG_DATA) matDialogData: {nextComponentRefAndInfo: Observable<ContentComponentInput>}) {
    super();

    this.nextComponentRefAndInfo = matDialogData.nextComponentRefAndInfo;
  }

  public ngOnInit(): void {
    this.nextComponentRefAndInfo.pipe(takeUntil(this.unSubscribeOnViewDestroy)).subscribe((contentComponentInput: ContentComponentInput) => {
      if (contentComponentInput?.destroyPrevious) {
        this.contentSwitcherContainer.clear();
      } else {
        this.contentSwitcherContainer.detach();
      }

      this.contentSwitcherContainer.insert(contentComponentInput.componentRef.hostView);
    });
  }
}
